<template>
<v-card>
    <v-card-title class="pt-0 pb-0">
        <template>
            <v-row align-content="center">
                <v-col cols="6">
                    <span>Inventario de {{ storehouseSelected.name }}</span>
                    <span v-if="storehouseSelected.mobility" class="detail-repartidor">Repartidor: {{ storehouseSelected.deliveryman }}</span>
                </v-col>
                <v-col cols="6" align-self="center">
                    <div class="float-right">
                        <v-btn dark color="green darken-1" class="mr-5" 
                            @click="handleRegisterRecharge(storehouseSelected)"
                            v-if="verifyPermission('registrar_recarga_storehouse')">
                            Recargar
                        </v-btn>
                        <v-btn dark color="amber darken-1" class="mr-5" 
                            @click="handleRegisterDecrease(storehouseSelected)"
                            v-if="verifyPermission('registrar_merma_storehouse')">
                            Merma
                        </v-btn>
                        <v-btn dark color="red darken-1" 
                            v-if="storehouseSelected.mobility && verifyPermission('registrar_descargar_storehouse')" 
                            @click="handleRegiserDischarge(storehouseSelected)">
                            Descargar
                        </v-btn>
                    </div>                    
                </v-col>
            </v-row>
        </template>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="detail-storehouse wost-scroll">
        <list-products></list-products>
    </v-card-text>
    <Movement ref="movement"></Movement>
</v-card>    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import ListProducts from './ListProducts'
import Movement from './Movement'

export default {
    name: 'DetailStorehouse',
    components: {
        ListProducts,
        Movement
    },
    computed: {
        ...mapState('storehouses', [
            'storehouseSelected'
        ]),
    },
    methods: {
        ...mapActions('storehouses', [
            'runSetStorehouses',
            'getStorehouses',
            'runSetStorehouseSelected',
            'selectStorehouseMain',
            'getProductsInStorehouse'
        ]),
        handleRegisterRecharge(storehouse) {
            this.$refs.movement.showForm('Ingreso de stock', 'recharge')
        },
        handleRegisterDecrease(storehouse) {
            this.$refs.movement.showForm('Registro de merma', 'decrease')
        },
        handleRegiserDischarge(storehouse) {
            this.$refs.movement.showForm('Registro de descarga', 'discharge')
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    }
}
</script>

<style>
.detail-storehouse{
    height: 74vh;
    overflow-y: auto;
}
.detail-repartidor{
    display: block;
    font-size:14px
}
</style>